import { Box, Flex, Heading, Text, Image, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import LogoText from "../assets/images/logoText.png";

export const BookingLinkNotFound = () => {
  const navigate = useNavigate();

  return (
    <Flex
      minH="100vh"
      bg="linear-gradient(180deg, #FFFFFF 0%, #FFF7F3 60%, #D8F1F2 100%)"
      align="center"
      justify="center"
      px="20px"
    >
      <Flex
        flexDir="column"
        align="center"
        maxW="480px"
        w="100%"
        textAlign="center"
      >
        <Text
          fontSize={{ base: "80px", md: "120px" }}
          fontWeight={800}
          lineHeight={1}
          color="#FF8E3C"
          opacity={0.5}
          fontFamily="RedHatDisplay-Bold"
          userSelect="none"
        >
          404
        </Text>

        <Heading
          fontSize={{ base: "24px", md: "32px" }}
          color="#19202D"
          mt="-10px"
        >
          Link Not Found
        </Heading>

        <Box
          h="3px"
          w="60px"
          borderRadius="10px"
          bg="#FF8E3C"
          my="20px"
        />

        <Text
          fontSize={{ base: "15px", md: "17px" }}
          color="#4F4F51"
          lineHeight="26px"
        >
          The booking link you followed doesn't match any stylist on our
          platform. It may have been changed or removed.
        </Text>

        <Text
          fontSize={{ base: "15px", md: "17px" }}
          color="#4F4F51"
          lineHeight="26px"
          mt="12px"
        >
          Please reach out to your stylist directly for the correct link.
        </Text>

        <Button
          mt="36px"
          bg="#FF8E3C"
          _hover={{ bg: "#e07a30" }}
          borderRadius="30px"
          color="white"
          h="52px"
          px="40px"
          fontSize="16px"
          fontFamily="RedHatDisplay-Bold"
          onClick={() => navigate("/")}
        >
          Back to Home
        </Button>

        <Flex align="center" gap="6px" mt="48px" opacity={0.6}>
          <Text fontSize="13px" color="#4F4F51">
            Powered by
          </Text>
          <Image src={LogoText} h="18px" objectFit="contain" />
        </Flex>
      </Flex>
    </Flex>
  );
};
